import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from "../../../components/Seo";

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { WebDate } from "../../../components/WebDate";
import { GetCourseWidget } from "../../../components/GetCourseWidget";
import { FooterMedium } from "../../../components/FooterMedium";
import { HeaderLogoAndTel } from "../../../components/HeaderLogoAndTel";
import { Modal } from "../../../components/Modal";

import * as main from "./style/main.module.scss";
import * as screen1 from "./style/screen1.module.scss";
import * as know from "./style/know.module.scss";
import * as speaker from "./style/speaker.module.scss";
import * as vids from "./style/vids.module.scss";
import * as partners from "./style/partners.module.scss";
const Screen1 = ({ widget, id }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <section className={screen1.screen1}>
      <div className="container">
        <HeaderLogoAndTel/>
        <div className={`row ${screen1.row}`}>
          <div className="col-12">
            <p className={screen1.date}>
              <WebDate id={id}/>
            </p>

            <h1 className={main.titleBig}>Как воспитать<br/>самостоятельного<br/>ребёнка</h1>
            <p className={screen1.postTitle}>
              чтобы он перестал мучиться <br/>с&nbsp;домашними заданиями<br/>и&nbsp;мучить вас
            </p>
            <button className={main.btn} onClick={()=>{setShowModal(true)}}>Зарегистрироваться</button>
            <p className={screen1.postButton}>
              Инструкция<br/>«5 шагов, чтобы ребёнок учился сам»
            </p>
          </div>
        </div>
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        { widget }
      </Modal>
    </section>
  );
};
const Know = ({ widget }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <section className={know.know}>
      <div className="container">
        <h2 className={main.titleBig}>На вебинаре вы узнаете:</h2>
        <div className={`row ${know.row}`}>
          <div className="col-12 col-md">
            <div className={know.itemWrapper}>
              <img src="https://fs.advance.ru/landing-pages/webinar/5_shagov_dlja_rebenka_dz/5steps-icon-1.svg" alt=""/>
              <p>Почему дети теряют<br/>интерес к&nbsp;учёбе?</p>
            </div>
          </div>
          <div className="col-12 col-md">
            <div className={know.itemWrapper}>
              <img src="https://fs.advance.ru/landing-pages/webinar/5_shagov_dlja_rebenka_dz/5steps-icon-2.svg" alt=""/>
              <p>Как вернуть интерес к<br/>&nbsp;обучению?</p>
            </div>
          </div>
          <div className="col-12 col-md">
            <div className={know.itemWrapper}>
              <img src="https://fs.advance.ru/landing-pages/webinar/5_shagov_dlja_rebenka_dz/5steps-icon-3.svg" alt=""/>
              <p>Как запоминать и&nbsp;понимать<br/>школьную программу?<br/>Конкретные инструменты</p>
            </div>
          </div>
        </div>
        <div className={`row justify-content-center ${know.row}`}>
          <div className="col-12 col-md-4">
            <div className={know.itemWrapper}>
              <img src="https://fs.advance.ru/landing-pages/webinar/5_shagov_dlja_rebenka_dz/5steps-icon-4.svg" alt=""/>
              <p>Как убрать пробелы<br/>и&nbsp;улучшить успеваемость?</p>
            </div>
          </div>
          <div className="col-12 col-md-4">
            <div className={know.itemWrapper}>
              <img src="https://fs.advance.ru/landing-pages/webinar/5_shagov_dlja_rebenka_dz/5steps-icon-5.svg" alt=""/>
              <p>Как передать ребёнку<br/>ответственность<br/>за&nbsp;его обучение?</p>
            </div>
          </div>
        </div>
        <button className={main.btn} onClick={()=>{setShowModal(true)}}>Хочу на вебинар</button>
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        { widget }
      </Modal>
    </section>
  );
};
const Speaker = () => {
  return (
    <section className={speaker.speaker}>
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-4">
            <img src="https://fs.advance.ru/landing-pages/webinar/5_shagov_dlja_rebenka_dz/nja-circle.png" alt=""/>
          </div>
          <div className="col-12 col-md-8">

            <h2>Ведущий — <br/>
              <span>Николай Ягодкин</span></h2>
            <ul>
              <li>Автор технологий обучения, педагог, эксперт в&nbsp;обучении детей;</li>
              <li>Автор книги «Энциклопедия детской мотивации»;</li>
              <li>Отзывов о&nbsp;результатах применения его технологий больше 35&nbsp;000;</li>
              <li>Основатель и&nbsp;владелец образовательного центра Advance, полные программы которого прошли более 80&nbsp;000&nbsp;человек по&nbsp;всему миру.</li>
            </ul>

          </div>
        </div>
      </div>
    </section>
  );
};
const Vids = ({ widget }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <section className={vids.vids}>
      <div className="container">
        <h2 className={main.titleSmall}>Ученики об Advance</h2>
        <div className="row">
          <div className="col-12 col-md-8">
            <div className={vids.bg}>
              <iframe src="https://www.youtube.com/embed/fp7X39n9fqM" title={"Ученики об Advance, видео 1"} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
            </div>
          </div>
          <div className={`col-12 col-md-4 ${vids.right}`}>
            <div className={vids.bg}>
              <iframe src="https://www.youtube.com/embed/svGFYzlv0dg" title={"Ученики об Advance, видео 2"} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
            </div>
            <div className={vids.bg}>
              <iframe src="https://65395.servicecdn.ru/videos/65395_EpqBixgJGO1dhwZz" title={"Ученики об Advance," +
                " видео 3"} allow="autoplay; fullscreen" allowFullScreen></iframe>
            </div>
          </div>
        </div>

        <button className={main.btn} onClick={()=>{setShowModal(true)}}>Прийти на&nbsp;вебинар</button>
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        { widget }
      </Modal>
    </section>
  );
};
const Partners = () => {
  return (
    <section className={partners.partners}>
      <div className="container">
        <h2 className={main.titleSmall}>Нам доверяют</h2>
        <div className={`row justify-content-center ${partners.row}`}>
          <div className="col-6 col-md-3 col-lg-2"><img src="https://fs.advance.ru/landing-pages/webinar/5_shagov_dlja_rebenka_dz/l1.jpg" alt=""/></div>
          <div className="col-6 col-md-3 col-lg-2"><img src="https://fs.advance.ru/landing-pages/webinar/5_shagov_dlja_rebenka_dz/l2.jpg" alt=""/></div>
          <div className="col-6 col-md-3 col-lg-2"><img src="https://fs.advance.ru/landing-pages/webinar/5_shagov_dlja_rebenka_dz/l3.jpg" alt=""/></div>
          <div className="col-6 col-md-3 col-lg-2"><img src="https://fs.advance.ru/landing-pages/webinar/5_shagov_dlja_rebenka_dz/l4.jpg" alt=""/></div>
          <div className="col-6 col-md-3 col-lg-2"><img src="https://fs.advance.ru/landing-pages/webinar/5_shagov_dlja_rebenka_dz/l5.jpg" alt=""/></div>
          <div className="col-6 col-md-3 col-lg-2"><img src="https://fs.advance.ru/landing-pages/webinar/5_shagov_dlja_rebenka_dz/l6.jpg" alt=""/></div>
          <div className="col-6 col-md-3 col-lg-2"><img src="https://fs.advance.ru/landing-pages/webinar/5_shagov_dlja_rebenka_dz/l7.jpg" alt=""/></div>
          <div className="col-6 col-md-3 col-lg-2"><img src="https://fs.advance.ru/landing-pages/webinar/5_shagov_dlja_rebenka_dz/l8.jpg" alt=""/></div>
          <div className="col-6 col-md-3 col-lg-2"><img src="https://fs.advance.ru/landing-pages/webinar/5_shagov_dlja_rebenka_dz/l9.jpg" alt=""/></div>
          <div className="col-6 col-md-3 col-lg-2"><img src="https://fs.advance.ru/landing-pages/webinar/5_shagov_dlja_rebenka_dz/l10.jpg" alt=""/></div>
          <div className="col-6 col-md-3 col-lg-2"><img src="https://fs.advance.ru/landing-pages/webinar/5_shagov_dlja_rebenka_dz/l11.jpg" alt=""/></div>
          <div className="col-6 col-md-3 col-lg-2"><img src="https://fs.advance.ru/landing-pages/webinar/5_shagov_dlja_rebenka_dz/l12.jpg" alt=""/></div>
        </div>
      </div>
    </section>
  );
};
const TITLE = 'Бесплатный вебинар “5 шагов, чтобы ребенок учился сам, перестал мучиться с домашними заданиями и мучить вас” от Advance';
const DESCRIPTION = 'Узнайте 5 простых шагов для того, чтобы ребенок учился самостоятельно, не мучился с домашними заданиями и перестал мучить вас на бесплатном вебинаре от центра образовательных технологий Advance.';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = ({ widget=<GetCourseWidget hash={'7ed9aa0c97b287aa253c0c3410465615a2633d20'} id={'301979'}/> }) => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main style={{ fontFamily: `"Roboto", sans-serif`, color: "#1A2E35" }}>
      <Screen1 id={'rus'} widget={widget}/>
      <Know widget={widget}/>
      <Speaker/>
      <Vids widget={widget}/>
      <Partners/>
    </main>

    <FooterMedium/>

  </DefaultLayout>
);
export default Page;
